module.exports = __webpack_public_path__ + "static/media/logo_inverted.22c4c7f6.png";